function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
let menuDrawerLayer = document.querySelector(".card-drawer-overlay");

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }
  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    if (menuDrawerLayer && menuDrawer ) {
      menuDrawerLayer.classList.add('overlay-drawer');
      menuDrawer.classList.add("menu-drawer")
    }
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

// TO CLOSE THE MENU IN MOBILE
let MobileMenu = document.querySelector('.menu-drawer-container');
let drawerOverlay = document.querySelector(".card-drawer-overlay")
let menuDrawer = document.querySelector(".custom-menu-layout-overlay")
// drawer overlay
drawerOverlay.addEventListener("click",()=>{
 if (menuDrawerLayer && menuDrawer) {
  menuDrawerLayer.classList.remove('overlay-drawer');
  document.body.style.overflow = "auto";
 }

  if (MobileMenu.hasAttribute("open")) {
    setTimeout(() => {
      MobileMenu.removeAttribute("open");
    }, 500);
    MobileMenu.classList.remove("menu-opening");
    document.querySelector("body").classList.remove("overflow-hidden-tablet");
  }
})

//mega menu open and close on hover
document.querySelectorAll(".mega-menu").forEach((element) => {
  element.addEventListener("mouseover", function (event) {
    document.querySelectorAll(".mega-menu").forEach((element) => {
      element.removeAttribute("open");
    });
    let currentElement = event.srcElement;
    let details = currentElement.closest(".mega-menu");
    details.setAttribute("open", " ");
  });
});

document.querySelectorAll(".mega-menu__content").forEach((element) => {
  element.addEventListener("mouseout", function (event) {
    let currentElement = event.srcElement;
    let details = currentElement.closest(".mega-menu");
    details.removeAttribute("open");
  });
});
document.querySelectorAll(".header__menu-item.link--text").forEach((element) => {
  element.addEventListener("mouseover", function (event) {
    document.querySelectorAll(".mega-menu").forEach((element) => {
      element.removeAttribute("open");
    });
  });
});
const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus?.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super(); 
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.handleButtonClick.bind(this))
    );

    this.debounceTimeout = null;
  }

  debouncedButtonClick(event) {
    event.preventDefault();
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => {
      this.onButtonClick(event);
    }, 700); // Adjust the debounce delay (in milliseconds) as per your requirement
  }

  // Use this function to avoid repeated triggers
  handleButtonClick(event) {
    event.preventDefault();

    const button = event.currentTarget;

    if (button.disabled) {
      return;
    }

    button.disabled = true;

    this.onButtonClick(event);

    setTimeout(() => {
      button.disabled = false;
    }, 2000);
  }

  onButtonClick(event) {
    const previousValue = this.input.value;
    const currentValue = parseInt(this.input.value, 10);
    const newValue = event.target.name === 'plus' ? currentValue + 1 : currentValue - 1;

    // Formatting the new value to add leading zero if necessary
    const formattedValue = newValue < 10 ? '0' + newValue : newValue;

    this.input.value = formattedValue;

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');

    // when click on details element previous details element is closed
    if (!detailsElement.classList.contains('menu-opening')) {
      const headerMenuItems = parentMenuElement?.querySelectorAll('.drawer-menu__item');
      headerMenuItems?.forEach((each) => { 
        each.removeAttribute('open');
        each.classList.remove('menu-opening');
      });
      
      const headerSubMenuItems = parentMenuElement?.querySelectorAll('.drawer-submenu__item');
      headerSubMenuItems?.forEach((each) => { 
        each.removeAttribute('open');
        each.classList.remove('menu-opening');
      });
    }

    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    const parentContainer = this.closest(".custom-filter-sort-container")
    if (parentContainer) parentContainer.classList.add("adjust-z-index")
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    setTimeout(() => { // Adjust z-index after a slight delay
      const parentContainer = this.closest(".custom-filter-sort-container")
      if (parentContainer) parentContainer.classList.remove("adjust-z-index")
    }, 500)
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);

    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    let autoPlay = this.getAttribute('data-media-autoplay') === 'true';
    if (!poster) return;
    if (autoPlay) {
      this.loadContent();
    } else {
      poster.addEventListener('click', this.loadContent.bind(this));
    }
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (this.getAttribute("data-media-autoplay") == "true") {
        deferredElement.src += "&autoplay=1";
      }
      if (focus) deferredElement.focus();
      //if custom video is there it will be played
      this.querySelector("video")?.play();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);


class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {

    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}



class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.init();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    // If variants are being selected inside Quick View,
    // do not update the URL, as this would trigger the product template page flow.
    const quickView = this.closest(".card-upsell-popover") || null;
    if (!quickView) this.updateURL();

    this.updateRaffleId();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  //Was added to show history

  init() {
    this.updateOptions();
    this.updateMasterId();
    this.updateURL();
    this.updateCollectionSize();
  }

  updateCollectionSize() {
    // Taking adding PLP selected size in sessionstorage and show selected size in pdp
    if (document.referrer.includes('collection')) {
      const collectionUrl = document.referrer
      const urlOptions = collectionUrl.split('&')
      for (const item of urlOptions) {
        if (item.includes('size')) {
          const sizeValue = item.split('=')[1]; // Extract size from the item
          const selectedSize = sizeValue;
          sessionStorage.setItem('collectionSelectedSize', selectedSize)
          break; // Break the loop after finding the first occurrence
        } else {
          sessionStorage.setItem('collectionSelectedSize', null)
        }
      }
    } else {
      sessionStorage.setItem('collectionSelectedSize', null);
    }
    if (sessionStorage.getItem('collectionSelectedSize') !== "null" && this.currentVariant) {
      this.updateVariantInput();
    }
  }

  updateRaffleId() {
    if (this.currentVariant && document.querySelector('[name="variantId"]')) {
      document.querySelector('[name="variantId"]').value = this.currentVariant.id;
    }
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    // mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {

    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    const warningMsg = document.querySelector('.variant-warning-msg')
    const popupWarningMsg = document.querySelector('.popup-variant-warning-msg')
    //Target Element based on selected option
    const selectedOption = this.currentVariant.option1
    const stickySelectedVariant = document.querySelector(`.sticky-variant__selector input[value="${selectedOption}"] + label`)
    const selectedVariant = document.querySelector(`.product__info-wrapper input[value="${selectedOption}"]`)
    const stickySelectedText = document.querySelector('.sticky-variant__selector .selected__variant-text');
    const selectedVariantId = this.currentVariant?.id; // Store the selected variant ID

  if (!document.querySelector('.card-upsell-popover').hasAttribute('open')) {
    // Store the selected variant ID in sessionStorage
    if (selectedVariantId) {
      sessionStorage.setItem(`${window.location.pathname}`, selectedOption);
    }
    //remove last selected value 
    const stickyvariantListLabel = document.querySelectorAll('.sticky-variant-dropdown input[type="radio"]+ label');
    stickyvariantListLabel?.forEach((each) => each.classList.remove('selected-sticky-variant-label'))
    if (selectedVariant && stickySelectedText) {
      stickySelectedText.textContent = selectedOption
      selectedVariant.checked = true
    }
  }
    stickySelectedVariant?.classList.add('selected-sticky-variant-label');
    warningMsg?.classList.add('hidden')
    popupWarningMsg?.classList.add('hidden')
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        if (document.querySelector(".recaptcha")) {
          grecaptcha?.reset()
        }

        if (document.querySelector(".recaptcha p")) {
          document.querySelector(".recaptcha p").style.display = "none";
        }

        // Update the similar products container
        const existingContainer = document.querySelector(".similar-products-container");
        const updatedContainer = html.querySelector(".similar-products-container");

        if (existingContainer && updatedContainer) {
          existingContainer.innerHTML = updatedContainer.innerHTML;
        }

        window.updateStickyvalue(); // Re-calculate the StickyTopValue of Product Info
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const stickyAddButton = document.querySelector('.sticky-product-form__button [name="add"]');
    const stickyAddButtonText = document.querySelector('.sticky-product-form__button [name="add"] > span');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;


    let message = document.querySelector(".out-stock_message");
    if (message) {
      message.style.display = "none";
    }
    if (disable) {
      if (text && text.toLowerCase() !== "add to cart") {
        addButton.setAttribute('disabled', 'disabled');
        stickyAddButton?.setAttribute('disabled', 'disabled');
      }

      if (text) {
        addButtonText.textContent = text;
        if (stickyAddButtonText) {
          stickyAddButtonText.textContent = text;
        }
      }

    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      stickyAddButton?.removeAttribute('disabled');
      if (stickyAddButtonText) {
        stickyAddButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    //for fcfs product
    if (sessionStorage.getItem("Added") == "true" && document.querySelector("[data-fcfsproduct='true']")) {
      document.querySelector(".product-form__submit").setAttribute("disabled", true);
      document.querySelector(".sticky-product-form__button .product-form__submit").setAttribute("disabled", true);
      if (document.querySelector(".product-form__submit span")) {
        document.querySelector(".product-form__submit span").textContent = "Added to the cart";
        document.querySelector(".sticky-product-form__button .product-form__submit span").textContent = "Add to cart";
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);






class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const collectionSelectedSize = sessionStorage.getItem("collectionSelectedSize");
      if (Array.from(fieldset.querySelectorAll('input[value]')).find((radio) => radio.checked)) {
        return Array.from(fieldset.querySelectorAll('input[value]')).find((radio) => radio.checked)?.value
      }
      else if (collectionSelectedSize !== 'null' || collectionSelectedSize != null || collectionSelectedSize) {
        return collectionSelectedSize
      }
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }

          const customEvent = new Event('quick-add');
          document.dispatchEvent(customEvent);

        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}
customElements.define('product-recommendations', ProductRecommendations);

class InfinitePageLoader extends HTMLElement {
  constructor() {
    super();

    this.sectionID = this.dataset.section || document.querySelector('infinite-page-loader')?.dataset.section || ''
    this.collectionInnerElement = document.querySelector('#product-grid')
    this.saveScrollPoint();
    this.restoreScrollPoint();
  }

  connectedCallback() {
    setInterval(function () {
      if (document.querySelector(".mobile-facets__sort")) {
        document.querySelector(".mobile-facets__sort").addEventListener("click", function () {
          this.classList.toggle("active");
          document.querySelector(".sorting-select_wrapper").classList.toggle("active");
        })
      }

      //for svg change in mobile sorting
      let sortingbtn = document.querySelectorAll(".sorting-label");
      if (sortingbtn) {
        for (let i = 0; i < sortingbtn.length; i++) {
          // sortingbtn[0].classList.add("active");
          sortingbtn[i].addEventListener("click", function () {
            let current = document.getElementsByClassName(" active");
            current[0].className = current[0].className.replace("active", "");
            this.className += " active";
          })
        }
      }
    }, 1000);
    this.init()
  }

  init() {
    this.addObserver();

  }

  addObserver() {
    const observer = new window.IntersectionObserver(([entry]) => {

      // entry.target.style.border = '5px solid red';
      if (entry.isIntersecting) {
        if (entry.target == this.loadActivatorElem)
          observer.disconnect();

        // entry.target.style.border = '5px solid blue';

        var nextPageUrl = this.getNextPageUrl()

        if (nextPageUrl)
          this.loadProducts(nextPageUrl)
      }

    }, {
      root: null,
      threshold: 0.1
    })

    observer.observe(this)
  }

  getNextPageUrl() {
    var nextPage = parseInt(this.dataset.currentpage) + 1;

    if (nextPage > this.dataset.totalpages) {
      return false
    }

    return this.constructURLWithSearchParams(nextPage)
  }

  constructURLWithSearchParams(page) {
    var params = new URLSearchParams(document.location.search)
    var nextPage = parseInt(page) || parseInt(this.dataset.currentpage) + 1;

    params.set('page', nextPage)
    // params.set('filter.v.availability', 1)

    var searchParamsAsString = params.toString()

    return "".concat(window.location.pathname, "?").concat(searchParamsAsString)
  }

  updateCurrentURL(url) {
    if (history.replaceState) {
      window.history.pushState({
        path: url
      }, '', url);
    }
  }

  loadProducts(url) {
    if (this.classList.contains('loading')) return;

    this.classList.add('loading')

    this.getAndInsertHtml(url, 'append')
  }

  getAndInsertHtml(url, insertPosition) {
    var _this4 = this;

    if (this.abortController) {
      this.abortController.abort();
    }
    var currentUrl = new URL(url, window.location.href);
    currentUrl.searchParams.set('section_id', this.sectionID);

    try {
      this.abortController = new AbortController();

      fetch(currentUrl.toString(), {
        signal: this.abortController.signal
      }).then(function (response) {
        response.text().then(function (content) {
          var tempElement = new DOMParser().parseFromString(content, "text/html");

          if (insertPosition == 'append') {
            _this4.collectionInnerElement.innerHTML += tempElement.querySelector('#product-grid').innerHTML; //Appending new sets of product cards
            _this4.dataset.currentpage = tempElement.querySelector('infinite-page-loader').dataset.currentpage
            _this4.dataset.totalpages = tempElement.querySelector('infinite-page-loader').dataset.totalpages
          }
          else if (insertPosition == 'prepend') {
            _this4.collectionInnerElement.insertAdjacentHTML('afterbegin', tempElement.querySelector('#product-grid').innerHTML);
            _this4.dataset.currentpage = tempElement.querySelector('load-previous-page').dataset.currentpage
          }

          _this4.init();
          _this4.saveScrollPoint();

          _this4.classList.remove('loading')
        });
      });
    } catch (exception) { }
  }

  saveScrollPoint() {
    let productCards = document.querySelectorAll(".product-card-wrapper");

    productCards.forEach((productCard) => {
      const observer = new IntersectionObserver((entries) => {
        observerCallback(entries, observer, productCard)
      },
        { threshold: 0.7 });
      observer.observe(productCard); //observing each product card that is visible

      productCard.addEventListener('click', () => {
        sessionStorage.setItem("lastElementId", productCard.id);
      });
    })

    const observerCallback = (entries, observer, header) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          this.updateCurrentURL(this.constructURLWithSearchParams(entry.target.dataset.page)) //updating the url depending on the product viewed
        }
      });
    };
  }

  restoreScrollPoint() {
    // Returning if browser is safari as it gets scrolled to top after scrollIntoView method is used.
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) return;

    history.scrollRestoration = "manual";
    //Reverting back to the previous element that was being viewed. 
    window.onload = function () {
      var lastElementId = sessionStorage.getItem("lastElementId");
      var lastElement = document.getElementById(lastElementId);

      if (lastElement)
        lastElement.scrollIntoView();

      sessionStorage.removeItem('lastElementId');
    };
  }
}

customElements.define('infinite-page-loader', InfinitePageLoader);

class LoadPreviousPage extends InfinitePageLoader {
  constructor() {
    super();

    this.addEventListener('click', this.loadProducts.bind(this));
  }

  connectedCallback() {
    this.init()
  }

  init() {
    var infinitePageLoader = document.querySelector('infinite-page-loader')
    var maxPagesLoadable = this.dataset.totalpages - 1;

    if (infinitePageLoader.dataset.currentpage - this.dataset.currentpage == maxPagesLoadable //when all the pages are loaded
      || this.dataset.currentpage == 1) { //When user is at page 1
      this.classList.add('hidden')
    } else {
      this.classList.remove('hidden')
    }

  }

  loadProducts() {
    if (this.classList.contains('loading')) return;

    var prevPageUrl = this.getPrevPageUrl()

    if (prevPageUrl) {
      this.classList.add('loading')
      this.getAndInsertHtml(prevPageUrl, 'prepend')
    }
  }

  getPrevPageUrl() {
    var prevPage = parseInt(this.dataset.currentpage) - 1;

    if (prevPage < 1) {
      return false
    }

    return this.constructURLWithSearchParams(prevPage)
  }
}

customElements.define('load-previous-page', LoadPreviousPage);



/* Blog Banner */
let articleCard = document.querySelectorAll(".featured-article-card");
let blogBanner = document.querySelector(".blog_image");
let blogBannerMobile = document.querySelector(".blog_image-mobile");
let blogTitle = document.querySelector(".title_of--blog")
let blogTitleMobile = document.querySelector(".title_of--blog-mobile")
let blogUrl = document.querySelector(".article_url");
let blogUrlMobile = document.querySelector(".article_url-mobile");
if (blogBanner || blogBannerMobile) {
  blogBanner.src = articleCard[0].querySelector("img").src.split('&')[0];
  blogBannerMobile.src = articleCard[0].querySelector("img").src.split('&')[0];
  blogUrl.href = articleCard[0].getAttribute('data-url');
  blogUrlMobile.href = articleCard[0].getAttribute('data-url');
  articleCard.forEach((article) => {
    articleCard[0].classList.add("active");
    article.addEventListener("click", function () {
      blogBanner.style.display = "none";
      blogBannerMobile.style.display = "none";
      let currentActive = document.querySelector(".active");
      currentActive.classList.remove("active");
      article.classList.add("active");
      blogBanner.src = article.querySelector("img").src.split('&')[0];
      blogBannerMobile.src = article.querySelector("img").src.split('&')[0];
      blogTitle.innerHTML = article.querySelector(".article-title").textContent;
      blogTitleMobile.innerHTML = article.querySelector(".article-title").textContent;
      blogUrl.href = article.getAttribute('data-url');
      blogUrlMobile.href = article.getAttribute('data-url');
      blogBanner.style.transform = "translateY(-100%)";
      blogBannerMobile.style.transform = "translateY(-100%)";
      setTimeout(() => {
        blogBanner.style.display = "block";
        blogBannerMobile.style.display = "block";

      }, 200)
      setTimeout(() => {
        blogBanner.style.transform = "translateY(0)";
        blogBannerMobile.style.transform = "translateY(0)";
      }, 400)
    });
  })
}

//code for text prior to upsell on pdp
document.addEventListener('DOMContentLoaded', function () {
  // Retrieve the previously selected variant ID from sessionStorage
  const storedVariantId = sessionStorage.getItem(`${window.location.pathname}`);
  sessionStorage.removeItem(`${window.location.pathname}`);
  // If a variant ID is stored, select it
  if (storedVariantId) {
    const selectedVariant = document.querySelector(`.product__info-wrapper input[value="${storedVariantId}"]`);
    const stickySelectedVariant = document.querySelector(`.sticky-variant__selector input[value="${storedVariantId}"] + label`)
    const stickySelectedText = document.querySelector('.sticky-variant__selector .selected__variant-text');
    // Trigger change event on the selected variant input to update UI

    const actualSelectedVariant = document.querySelector(".product__info-wrapper input[data-current-variant]")

    if (actualSelectedVariant && actualSelectedVariant.hasAttribute("data-current-variant")) {
      const value = actualSelectedVariant.value

      if (value === storedVariantId) {
        stickySelectedText.textContent = storedVariantId
        if (selectedVariant) selectedVariant.checked = true
        if (stickySelectedVariant) stickySelectedVariant.classList.add('selected-sticky-variant-label')
      }
    }
  }
  const hasvalue = document.querySelector(".product-off-text_line")?.getAttribute("data-one-line");
  const valueText = document.querySelector(".product-off-text_line")?.getAttribute("data-one-line-text");
  if (hasvalue) {
    let hasRun = false;

    const checkAndRun = () => {
      const targetElement = document.querySelector('lb-upsell-product-page-addon');

      if (targetElement && !hasRun) {
        const htmlContent = '<div class="before-description-text">' + valueText + '</div>';
        const newElement = document.createElement('div');
        newElement.innerHTML = htmlContent;
        targetElement.parentNode.insertBefore(newElement, targetElement);
        hasRun = true;
      }
    };
    setInterval(checkAndRun, 1000);
  }
});

// close quick-buy-product popup
let popUpCloseButton = document.querySelector('buy-popover button.close-button');
popUpCloseButton.addEventListener('click', () => {
  const buyPopover = document.querySelector('buy-popover');
  document.querySelector("body").classList.remove("overflow-hidden");
  document.querySelector('.popup-overlay').classList.remove('popup-background-shadow')
  buyPopover.removeAttribute('open');     
});

let upcomingBadge = document.querySelector('.different_badge')?.textContent;

if (upcomingBadge != ''){
  // document.querySelector(".with-variants-button")?.classList.add('upcoming-special-product');
}

// Feature Collection
setTimeout(()=>{
  var container = document.querySelectorAll('.js-product-grid');
  if(container){
    // var productListLength = container.querySelectorAll(".product_list").length;
    if(window.innerWidth > 769){
      container.forEach(ele =>{
          var flkty = new Flickity( ele, {
          // options
          cellAlign: 'left',
          contain: true,
          wrapAround: true,
          arrowShape: { 
            x0: 10,
            x1: 40, y1: 30,
            x2: 45, y2: 25,
            x3: 20
          },
          pageDots: false
        });
      });
    }
    else{
      container.forEach(ele =>{
        ele.classList.add("mobile-flex_scroll");
      });
    }
  }
},500)

// st-search-box-desktop search icons
let searchBtn = document.querySelector('.custom-btn');
let searchInput = document.querySelector(".customsearch-placeholder")
let searchcontainer = document.querySelector(".custom-search-icon")

searchBtn?.addEventListener("click",()=>{
  if (searchcontainer.classList.contains("active")) {
    searchInput.value =""
  }
  else{
    searchcontainer.classList.add("active")
  }
})

// sort by-filter
// Custom sort by functionality for mobile
class CustomSortByFilter extends HTMLElement {
  constructor() {
    super();
    this.fetchedHtml = null;
    this.initializeVariables();
  }
  
  initializeVariables() {
    this.sortByFilterOpen = this.querySelector(".custom-sort-by-filter-btn");
    this.sortByFilterClose = this.querySelector(".custom-sort-by-close-btn");
    this.customSortByFilterContainer = this.querySelector(".custom-sort-by-filter-container");
    this.sortbycontainer = this.querySelector(".popover__overlay");
    this.sortByFilterOpen.addEventListener("click", this.openFilter.bind(this));
    this.sortByFilterClose.addEventListener("click", this.closeFilter.bind(this));

    const urlParams = new URLSearchParams(window.location.search);
    const sortByValue = urlParams.get('sort_by');
    if (sortByValue) {
      this.querySelectorAll("li").forEach(sortByListItem => {
        if (sortByListItem.dataset.sortValue === sortByValue) {
          sortByListItem.classList.add("active");
        }
      });
    }

    this.querySelectorAll("li").forEach(sortByListItem => {
      sortByListItem.addEventListener("click", this.handleSort.bind(this))
    });
  }

  openFilter() {
    this.customSortByFilterContainer.style.display = "block";
    document.body.style.overflow = "hidden";
    if (this.fetchedHtml != null) {
      this.removeClassName(this.fetchedHtml.querySelector(".custom-filter-mobile-style"));
      this.addClassName(this.fetchedHtml.querySelector(".custom-sort-by-filter-btn"));
    }
  }

  closeFilter() {
    document.body.style.overflow = "hidden";  
  }

  updateURL(url, sortValue) {
    const urlObj = new URL(url);
    urlObj.searchParams.set('sort_by', sortValue);
    return urlObj.toString();
  }

  handleSort(event) {
    this.querySelectorAll("li").forEach(sortByListItem => {
      sortByListItem.classList.remove("active")
    });

    event.target.classList.add("active")
    const sortValue = event.currentTarget.dataset.sortValue;
    const updatedUrl = this.updateURL(window.location.href, sortValue);

    fetch(updatedUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then(result => {
        const resultData = document.createElement("div");
        resultData.innerHTML = result;

        // Update product list section
        const newProducts = resultData.querySelector(".product-grid-container");
        const currentProducts = document.querySelector(".product-grid-container");
        
        if (newProducts && currentProducts) {
          currentProducts.innerHTML = newProducts.innerHTML;

          const customEvent = new Event('quick-add'); // Re-attach Quick view listeners
          document.dispatchEvent(customEvent);
        } else {
          console.error("Product list not found in the fetched content.");
        }

        window.history.replaceState({}, '', updatedUrl);
        this.closeFilter();
      })
      .catch(error => {
        console.error('Error fetching the sorted content:', error);
      });
  }
}
customElements.define('custom-sort-by-filter', CustomSortByFilter);

// opening the drawer
let customSortbyBtn = document.querySelector(".mobile-drawer .custom-sort-by-filter-btn");
let customSortFilter = document.querySelector(".custom-sort-by-filter.mobile-drawer")
let sortByText = document.querySelector(".mobile-drawer .custom-media-sort-filters")
let mobilefacetsopen = document.querySelector(".mobile-facets__open")
let sortbyoverlay = document.querySelector(".mobile-drawer .popover__overlay")
let customsortbyContainer = document.querySelector(".mobile-drawer .custom-sort-by-filter-container")
let customfiltersortcontainer = document.querySelector(".custom-filter-sort-container")

if (customSortbyBtn && customSortFilter && sortByText && mobilefacetsopen && sortbyoverlay && customsortbyContainer && customfiltersortcontainer) {

  customSortbyBtn.addEventListener("click", () => {
    customSortFilter.classList?.toggle("main-viewport");
    sortByText.classList.add("hidden");
    mobilefacetsopen.classList.add("hidden");
    sortbyoverlay.classList.add("overaly-open");
    customsortbyContainer.style.position = "unset";
    customsortbyContainer.style.transform = "translateY(0)";
    customfiltersortcontainer.style.margin="unset"
  });
}

// closing the cross icon
let sortbtn = document.querySelector(".mobile-drawer .custom-sort-by-close-btn")
if (sortbtn) {
  sortbtn.addEventListener("click", () => {
    if (customSortFilter && sortByText && mobilefacetsopen && sortbyoverlay && customsortbyContainer && customfiltersortcontainer) {
      customSortFilter.classList?.toggle("main-viewport");
      sortByText.classList.remove("hidden");
      mobilefacetsopen.classList.remove("hidden");
      sortbyoverlay.classList.remove("overaly-open");
      document.body.style.overflow = "unset";
      customsortbyContainer.style.position = "absolute";
      customsortbyContainer.style.transform = "translateY(100%)";
    customfiltersortcontainer.style.margin="auto"
    }
  });
}

// hiding the popup clicking on overlay
let sortbygray = document.querySelector(".mobile-drawer .popover__overlay")
let maincontainer = document.querySelector(".mobile-drawer .custom-media-container")
if (sortbygray && customSortFilter && sortByText && mobilefacetsopen && sortbyoverlay && customsortbyContainer && customfiltersortcontainer) {
  sortbygray.addEventListener("click", () => {
    sortByText.classList.remove("hidden");
    customSortFilter.classList?.toggle("main-viewport");
    mobilefacetsopen.classList.remove("hidden");
    sortbyoverlay.classList.remove("overaly-open");
    document.body.style.overflow = "unset";
    customsortbyContainer.style.position = "absolute";
    customsortbyContainer.style.transform = "translateY(100%)";
    customfiltersortcontainer.style.margin="auto"

  });
}

// tab switching for filters
document.addEventListener("DOMContentLoaded", function () {
  const filterLabels = document.querySelectorAll('.filter-label_wrapper')
  const filterLists = document.querySelectorAll('.filters-values-discount.mobile ul')
  const desktopFilterLists = document.querySelectorAll('.filters-values-discount.desktop ul')
  const facetsDrawer = document.querySelector(".facets-container-drawer")

  const MOBILE = window.matchMedia("(max-width:749px)")
  const DESKTOP = window.matchMedia("(min-width:750px)")

  if (facetsDrawer && facetsDrawer.hasAttribute("drawer-layout-on-mobile")) {
    toggleLabels(filterLabels, desktopFilterLists, false, true)
  } else {
    if (MOBILE.matches && filterLists.length > 0) {
      toggleLabels(filterLabels, filterLists, Boolean(facetsDrawer), false)
    } else if (DESKTOP.matches && desktopFilterLists.length > 0) {
      toggleLabels(filterLabels, desktopFilterLists, false, true)
    }
  }

  function toggleLabels(labels, lists, disableSortBy, typeDropdown) {

    const elIndex = disableSortBy ? 1 : 0
    lists[elIndex].classList.add("active")
    labels[elIndex].classList.add('filter-facets-active')

    labels.forEach((label, index) => {
      label.addEventListener('click', function () {

        if (typeDropdown) {
          lists[index].classList.toggle("active")
          label.classList.toggle("filter-facets-active")
        } else {
          toggleClasses(lists, lists[index], "active") 
          toggleClasses(labels, label, "filter-facets-active")
        }
      });
    });
  }

  function toggleClasses(eles,  el, className) {
    eles.forEach(list => list.classList.remove(className))
    el.classList.add(className)
  }
});

// clear all the filter which is selected (:This might be used in future)
// let clearAllBtn = document.querySelector(".clear-all");

// if (clearAllBtn) {
//   clearAllBtn.addEventListener("click", () => {
//     let checkedFilters = document.querySelectorAll(".mobile-facets__checkbox:checked");
    
//     if (checkedFilters.length > 0) {
//       checkedFilters.forEach(function(checkedFilter) {
//         checkedFilter.checked = false; 
//       });
//     }

//     // Clear active sortby values
//     const activeSortByValue = document.querySelectorAll(".custom-sort-by-value") || [];
//     if (activeSortByValue.length > 0) {
//       activeSortByValue.forEach(el => {
//         el.classList.remove("active")
//         const input = el.querySelector("input");
//         if (input && input.name === "sort_by") input.classList.remove("active-value");
//       })
//     }
//   });
// }

// clear all outside the filter 
class RemoveButton extends HTMLElement {
  constructor() {
    super();

    //clearall the outside the drawer
    const  clearAllButton = document.querySelector(".remove-clear-wrapper");
    if (clearAllButton) {
      clearAllButton.addEventListener("click",()=>{
        let checkedFilters = document.querySelectorAll(".mobile-facets__checkbox:checked");
        checkedFilters.forEach(function(checkedFilter) {
          checkedFilter.checked = false; 
        });

        // Clear active sortby values
        const activeSortByValue = document.querySelectorAll(".custom-sort-by-value") || [];
        if (activeSortByValue.length > 0) {
          activeSortByValue.forEach(el => {
            el.classList.remove("active")
          })
        }
      })
    }
  

    // clear the particluar element and unchecked the selected value
   document.querySelectorAll(".active-facets__button-inner").forEach((filteractiveelement) => {
  filteractiveelement.addEventListener("click", () => {
    let clickedFilterText = Array.from(filteractiveelement.childNodes)
      .filter(node => node.nodeType === Node.TEXT_NODE) 
      .map(node => node.textContent.trim()) 
      .join('');

    let checkedFilters = document.querySelectorAll(".mobile-facets__checkbox:checked");

    checkedFilters.forEach(function(checkedFilter) {
      let associatedLabel = checkedFilter.closest("label");
      let labelText = associatedLabel.querySelector("span[aria-hidden='true']").textContent.trim();
      if (clickedFilterText === labelText) {
        checkedFilter.checked = false;
      }
    });
  });
});
  }
}
customElements.define('remove-button', RemoveButton);


document.addEventListener("DOMContentLoaded", function () {
let sortvalue = document.querySelectorAll(".custom-sort-by-value");
// it will observe the changes in the element and then we updating
const observer = new MutationObserver(() => {
  if (document.body.style.overflow === "hidden") {
    document.body.style.overflow = "unset";
  }
});

observer.observe(document.body, { attributes: true, attributeFilter: ["style"] });
sortvalue.forEach((ele)=>{
ele.addEventListener("click",()=>{
  setTimeout(()=>{
    if (customsortbyContainer && customfiltersortcontainer && sortbyoverlay && customSortFilter && sortByText && mobilefacetsopen) {
      document.body.style.overflow = "unset";
      customsortbyContainer.style.position = "absolute";
      customsortbyContainer.style.transform = "translateY(100%)";
      customfiltersortcontainer.style.margin = "auto";
      sortbyoverlay.classList.remove("overaly-open");
      customSortFilter.classList?.toggle("main-viewport");
      sortByText.classList.remove("hidden");
      mobilefacetsopen.classList.remove("hidden");
      sortbyoverlay.classList.remove("overaly-open");
    }

  },1000)
})
})
});


class productStickybtn extends HTMLElement{

connectedCallback(){
  this.initaldata()
}
initaldata(){
  // selecting the elements
  let productmediabtn = document.querySelectorAll(".custom-sticky-addtocart");
  let floatingmediabtn = document.querySelector(".custom-media-floatingbtn");
  let mediapopup = document.querySelector(".sticky-container-modal");
  let stickycrossicon = document.querySelector(".sticky-addtocart-cross");
  let mediaoverlay = document.querySelector(".popover__overlays");
  let mainaddtocart = document.querySelector(".custom-main-addtocart")
  let variantRadios = this.querySelectorAll('.variant-radios-wrapper label')
  let mainVariantRadios = document.querySelectorAll('.variant-radios-wrapper.main input')
  let errorMsg = this.querySelector('.variant-warning-msg')
  let documentbody = document.querySelector("body")

 // matching the value of mainvariant and dataset value
  if(variantRadios){
    variantRadios.forEach((variantRadio)=>{
      variantRadio.addEventListener('click', (e)=>{

        // displaying the error message in popup
        if(!errorMsg.classList.contains('hidden')){
          errorMsg.classList.add('hidden')
        }
        let _this = e.currentTarget
        mainVariantRadios.forEach((mainVariantRadio)=>{
          if (mainVariantRadio.value === _this.dataset.value) {
            mainVariantRadio.checked = true; 
          } else {
            mainVariantRadio.checked = false;
          }

          // add to cart in the overlay modal
          var changeEvent = new Event('change', { bubbles: true, cancelable: true });
          mainVariantRadio.dispatchEvent(changeEvent);
        })

      })
    })
  }

  if (productmediabtn) {
    productmediabtn.forEach((productmediabtn)=>{
     productmediabtn.addEventListener("click",()=>{
      let variantradio = document.querySelectorAll(".variant-radios-wrapper input");
      let optionChecked = false
      variantradio.forEach((ele)=>{
        if (ele.checked){
          optionChecked = true
       }
      })
    // checking if variant is 
      const hasVariant = document.querySelector('.variant-radios-wrapper input[type="radio"]') || document.querySelector('variant-radios input[type="radio"]');
      const selectedVariant = document.querySelector('.variant-radios-wrapper input[type="radio"]:checked') || document.querySelector('variant-radios input[type="radio"]:checked');
      const noVariant = document.querySelector('.product-form__buttons')?.getAttribute('data-variant');
         if ((!hasVariant || selectedVariant && (selectedVariant.hasAttribute("value")) && optionChecked || noVariant )){
        mainaddtocart.click()
        mediapopup.classList.remove("sticky-media-tranform");
        mediaoverlay.classList.remove("overaly-opens");
       documentbody?.classList.remove('overflow-hide');   
  }  
      else{
        // popup moal should open in only in mobile view
        const isMobile = window.matchMedia("(max-width: 749px)").matches;
        if (!isMobile) return;

        //if variant is not selected then showing the popup
       
          mediapopup.classList.add("sticky-media-tranform");
          floatingmediabtn.classList.add("floating-btn-zindex");
  
      
         //background overlay
        mediaoverlay.classList.add("overaly-opens")
       documentbody?.classList.add('overflow-hide')
      }

    })
  })
  }
   
  //cross icon in popup
  if (stickycrossicon ) {
    stickycrossicon.addEventListener("click",()=>{
      mediapopup.classList.remove("sticky-media-tranform");
     mediaoverlay.classList.remove("overaly-opens")
     documentbody?.classList.remove('overflow-hide')

     floatingmediabtn.classList.remove("floating-btn-zindex");
    })
  }

// removing the overlay and close the popup
  if (mediaoverlay) {
    mediaoverlay.addEventListener("click",()=>{
    mediaoverlay.classList.remove("overaly-opens")
    mediapopup.classList.remove("sticky-media-tranform");
    documentbody?.classList.remove('overflow-hide')
    floatingmediabtn.classList.remove("floating-btn-zindex");
    })
  }
}

}

customElements.define("product-sticky-form",productStickybtn)




// display the all blogs based on the date
document.addEventListener("DOMContentLoaded", function () {
  //  sort blog articles by date
  function sortBlogArticlesByDate() {
    const allTab = document.querySelector("#blog-all .blog-articles-grid");
    if (!allTab) return;
    const articles = Array.from(allTab.querySelectorAll(".blog-article-card"));

    // sort data-date attribute (descending order)
    articles.sort((a, b) => {
      const dateA = new Date(a.dataset.date);
      const dateB = new Date(b.dataset.date);
      return dateB - dateA; 
    });
    allTab.innerHTML = "";
    articles.forEach((article) => {
      allTab.appendChild(article);
    });
  }
  sortBlogArticlesByDate();
});




let mobile_bottom = document.querySelector(".custom-media-mobilebottom");
let customnav = document.querySelector(".custom-menu-layout-overlay.gradient.menu-drawer");
let menuDrawerContainer = document.querySelector(".menu-drawer-container"); 
mobile_bottom?.addEventListener("click", () => {
menuDrawerLayer.classList.add('overlay-drawer');
menuDrawerContainer.setAttribute("open","open");
setTimeout(() => {
  menuDrawerContainer.classList.add("menu-opening");
}, 100);
});


// Save the scroll position before navigating away
window.addEventListener("beforeunload", () => {
  sessionStorage.setItem("scrollPosition", window.scrollY);
});
window.addEventListener("popstate", () => {
  const scrollPosition = sessionStorage.getItem("scrollPosition");
  if (scrollPosition) {
    window.scrollTo(0, parseInt(scrollPosition, 10));
  }
});



// Default Search Page For Search bar
let mainsearch_Tab = document.querySelector(".custom-search-input-field");
let mainsearch_desktop = document.querySelector(".custom-searhdesktop");

let mainBtn_Search = document.querySelector(".custom-button-media");
let mainCrossBtn_Search = document.querySelector(".custom-restbutton-search");
mainBtn_Search?.addEventListener("click",()=>{
  if (mainsearch_Tab && mainsearch_desktop) {
   mainsearch_Tab.classList.add("active")
   mainsearch_desktop.classList.add('active')
    }
})
let MobileSearchMedia = document.querySelector(".mobile-custom-button-media");
let MobileSearchField = document.querySelector(".custom-mobile-view-search");
let mobileLayoutview = document.querySelector(".mobile-view-searchfield")
let meidamobilesearch = document.querySelector('.shopify-section.section-header sticky-header.header-wrapper ')

MobileSearchMedia?.addEventListener("click",()=>{
  MobileSearchField.classList.toggle("active");
  if (MobileSearchField.classList.contains("active")) {
    mobileLayoutview.style.setProperty("padding", "10px", "important");
    meidamobilesearch.style.position = "unset";
  } else {
    mobileLayoutview.style.removeProperty("padding");
    meidamobilesearch.style.position = "absolute";

  }
})


// search and clear the input field
document.addEventListener("DOMContentLoaded", () => {
  const searchInputs = document.querySelectorAll('.search__input');
  const resetButtons = document.querySelectorAll('.reset__button');

  if (resetButtons.length && searchInputs.length) {
    resetButtons.forEach((button, index) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        if (searchInputs[index]) {
          searchInputs[index].value = '';
          searchInputs[index].focus(); 
        }
      });
    });
  }
});



// sticky header desktop and mobile
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.getElementById('shopify-section-header');
    this.headerBounds = {};
    this.currentScrollTop = 100;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // sticky header enable the color
    const headerHeight = document.querySelector('header').offsetHeight;
    let BannerHeight = document.querySelector('.custom-splide-review');
    const TotalHeight = BannerHeight ? BannerHeight.offsetHeight : 0;

    if (TotalHeight && scrollTop >= TotalHeight) {
      this.header.classList.add('sticky-header-banner');
    }
    else {
      this.header.classList.remove('sticky-header-banner');
    }


    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    if (this.searchModal) {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
   
  }
}

customElements.define('sticky-header', StickyHeader);


// Commented by team searchtap 
// search page making sticky header background
// const searchInputs = document.querySelector(".customsearch-placeholder");
// const header = document.querySelector(".shopify-section.section-header sticky-header.header-wrapper");

// searchInputs.addEventListener('input', function(event) {
//   const inputValue = event.target.value.trim();

//   if (inputValue !== "") {
//     header.classList.add("search-bar-header");
//   } else {
//     header.classList.remove("search-bar-header");
//   }
// });

// searchInputs.addEventListener("keydown",(event)=>{
// if (event.key === "Backspace" || event.key === "Delete") {
//    setTimeout(()=>{
//     if (searchInputs.value.trim() === "") {
//     header.classList.add("search-bar-header");
//     }
//    },0)
// }
// })

// // toogling the search bar in mobile color
// document.addEventListener("DOMContentLoaded", function () {
//   const searchIcon = document.getElementById("st-mobile-search-icon");
//   const headerWrapper = document.querySelector(".header-wrapper");

//   if (searchIcon && headerWrapper) {
//     searchIcon.addEventListener("click", function () {
//       headerWrapper.classList.toggle("active-searchBar");
//     });
//   }
// });


// // Mobile Search
// const searchField = document.querySelector(".mobile-searchbox");
// const mobileHeader = document.querySelector("sticky-header.header-wrapper");
// const crossiconmobile = document.querySelector("#st-searchbox-mobile .st-cross")
// const santhosh = document.querySelector(".st-search-bar.st-hidden-desktop");

// searchField.addEventListener('input', function (e) {
//   e.preventDefault();
//   mobileHeader.classList.add("mobile-search-bar");
// });
// crossiconmobile.addEventListener('click', () => {
//   mobileHeader.classList.remove("mobile-search-bar");
// });

// Accordion Footer
function AccordionFooter(){
let accordionHeading = [];
let accordionDescription = [];
let accordionIcons = [];

let footerAccordionHeading = document.querySelectorAll(".footer-headingmedium");
footerAccordionHeading.forEach((ele) => {
  accordionHeading.push(ele);
});

let footerAccordionDescription = document.querySelectorAll(".footer-description-media");
footerAccordionDescription.forEach((description) => {
  accordionDescription.push(description);
});

let footerIcons = document.querySelectorAll(".footer-accordion-icon");
footerIcons.forEach((icon) => {
  accordionIcons.push(icon);
});

accordionHeading.forEach((accordion, index) => {
  accordion.addEventListener("click", () => {
    if (window.innerWidth <= 768) { 
    accordionDescription[index].classList.toggle("hidden");
      accordionIcons[index].classList.toggle("rotated");
    }
    });
});

}
AccordionFooter()





// Mobile Mega menu accordion
class AccordionElement extends HTMLElement {
  constructor() {
    super();
    this.toggleItem = this.toggleItem.bind(this);
  }

  connectedCallback() {
    this.setupAccordionItems();
  }

  setupAccordionItems() {
    const accordionItems = this.querySelectorAll('.questions__group');
    accordionItems.forEach((item) => {
      const header = item.querySelector('.questions__header');
      if (header) {
        header.addEventListener('click', (event) => {
          const openItem = document.querySelector(".accordion-open");

          if (openItem && openItem !== item) {
            this.toggleItem(openItem);
          }
          this.toggleItem(item);
        });
      }
    });
  }

  toggleItem(item) {
    const content = item.querySelector('.questions__content');
    const plusIcon = item.querySelector('.icon-plus');
    const minusIcon = item.querySelector('.icon-minus');

    if (item.classList.contains('accordion-open')) {
      content.style.height = content.scrollHeight + 'px';
      requestAnimationFrame(() => {
        content.style.height = '0px';
      });
      item.classList.remove('accordion-open');
      minusIcon.classList.add('hidden');
      plusIcon.classList.remove('hidden');
    } else {
      // If it is a brands menu don't use calculations because the childlinks have read more / less type
      // functionality which has 0 height initially and so the scrollHeight won't work
      if (content.querySelector("#link-brands [data-childlink-title]")) {
        content.style.height = 'max-content';
      } else {
        content.style.height = content.scrollHeight + 'px';
      }
      item.classList.add('accordion-open');
      minusIcon.classList.remove('hidden');
      plusIcon.classList.add('hidden');
    }
  }
}

customElements.define('accordion-element', AccordionElement);



// Story Mode Desktop
  document.addEventListener("DOMContentLoaded", function () {
  const storyWrappers = document.querySelectorAll('.story-mode-wrapper');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
        } else {
          entry.target.classList.remove('animate');
        }
      });
    },
    {
      threshold: 0.5
    }
  );

  storyWrappers.forEach(wrapper => {
    observer.observe(wrapper);
  });
});



// Seo Text

document.addEventListener("DOMContentLoaded", () => {
  const wrapper = document.getElementById("SeoTextWrapper");
  const content = document.getElementById("SeoText");
  const button = document.getElementById("ToggleSeoText");
  const label = button.querySelector(".button-label");
  const icon = button.querySelector(".toggle-icon");

  requestAnimationFrame(() => {
    wrapper.style.height = `${content.getBoundingClientRect().height}px`;
  });

  button.addEventListener("click", () => {
    const isExpanded = content.classList.toggle("expanded");
    icon.classList.toggle("rotated", isExpanded);
    if (label) label.textContent = isExpanded ? "Read less" : "Read more";

    const fromHeight = wrapper.offsetHeight;
    content.classList.add("expanded");
    const toHeight = content.scrollHeight;
    content.classList.toggle("expanded", isExpanded);

    wrapper.style.height = fromHeight + "px";
    requestAnimationFrame(() => {
      wrapper.style.height = (isExpanded ? toHeight : content.getBoundingClientRect().height) + "px";
    });
  });
});


// lazy load

// -----LAZY LOADING SECTIONS-----
class LazySection extends HTMLElement {
  static sectionsToFetch = [];
  static totalSections = 0; // Total sections to be loaded
  static loadedSections = 0; // Count of sections loaded

  constructor() {
    super();
    
    this.section = this.closest('section')?.id || this.closest('[id]').id;
    this.section = this.section?.replace('shopify-section-', '');

    this.trigger = this.dataset.triggerEvent || 'intersection-observer';
    this.targetSelector = this.dataset.triggerTarget || 'body';

    // Reference to the footer
    this.footer = document.querySelector('footer.footer'); // Adjust as necessary

    this.boundHandleMouseover = this.handleMouseover.bind(this);
    this.boundHandleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    const targetElement = document.querySelector(this.targetSelector);

    if (this.trigger === 'mouseover') {
      if (screen.width < 990) return;
      targetElement.addEventListener('mouseover', this.boundHandleMouseover);
    } else if (this.trigger === 'click') {
      targetElement.addEventListener('click', this.boundHandleClick);
    } else {
      new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }

    // Initialize the total sections count if this is the first instance
    if (LazySection.totalSections === 0) {
      LazySection.totalSections = document.querySelectorAll('lazy-section').length;
    }
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    this.fetchSections();
  }

  handleMouseover() {
    this.removeTrigger();
    this.fetchSections();
  }

  handleClick() {
    this.removeTrigger();
    this.fetchSections();
  }

  fetchSections() {
    LazySection.sectionsToFetch.push(this.section);
    const sectionsToFetchBatch = LazySection.sectionsToFetch.length === 5 ? LazySection.sectionsToFetch.splice(0, 5) : LazySection.sectionsToFetch;

    if (LazySection.abortController) {
      LazySection.abortController.abort();
    }

    LazySection.abortController = sectionsToFetchBatch.length < 5 && new AbortController();
    
    fetch(window.location.pathname + '?sections=' + sectionsToFetchBatch.join(','), LazySection.abortController.signal ? { signal: LazySection.abortController.signal } : {})
      .then((response) => response.json())
      .then((json) => {
        for (const [key, value] of Object.entries(json)) {
          const sectionContent = new DOMParser().parseFromString(value, 'text/html').getElementById('shopify-section-' + key);

          if (sectionContent && sectionContent.innerHTML.trim().length) {
            const section = document.getElementById('shopify-section-' + key);
            section.innerHTML = sectionContent.innerHTML;
            
            section.querySelectorAll('script').forEach((oldScriptTag) => {
              const newScriptTag = document.createElement('script');
              Array.from(oldScriptTag.attributes).forEach((attribute) => {
                newScriptTag.setAttribute(attribute.name, attribute.value);
              });
              newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
              oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
            });
          }
        }

        LazySection.loadedSections += sectionsToFetchBatch.length;

        // Show footer if all sections are loaded
        if (LazySection.loadedSections === LazySection.totalSections && this.footer) {
          this.footer.classList.remove('hidden')
        }

        if (sectionsToFetchBatch.length < 5) {
          LazySection.sectionsToFetch = [];
        }
      })
      .catch((e) => {
        console.warn(e);
      }).finally(()=>{
        quickAddToCart()
      })
  }

  removeTrigger() {
    const targetElement = document.querySelector(this.targetSelector);

    if (targetElement) {
      targetElement.removeEventListener('mouseover', this.boundHandleMouseover);
      targetElement.removeEventListener('click', this.boundHandleClick);
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.checkAndLoadSections.bind(this));
  }  
}

customElements.define('lazy-section', LazySection);



// tab swtching using the recommendation product
class TabSwitcher extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll(".tab-button");
    this.panes = this.querySelectorAll(".tab-pane");
    this.indicator = this.querySelector(".tab-indicator");

    this.tabs.forEach(tab => {
      if (tab.classList.contains("active")) {
        this.moveIndicator(tab);
      }
      tab.addEventListener("click", () => this.switchTab(tab));
    });

    window.addEventListener("resize", () => {
      const activeTab = this.querySelector(".tab-button.active");
      if (activeTab) this.moveIndicator(activeTab);
    });
  }

  switchTab(tab) {
    this.tabs.forEach(t => t.classList.remove("active"));
    this.panes.forEach(p => p.classList.remove("active"));

    tab.classList.add("active");
    this.querySelector(`#${tab.dataset.tab}`).classList.add("active");

    this.moveIndicator(tab);
  }

  moveIndicator(tab) {
    this.indicator.style.width = tab.offsetWidth + "px";
    this.indicator.style.left = tab.offsetLeft + "px";
  }
}

customElements.define("tab-switcher", TabSwitcher);

// Find in store

class FindInStore extends HTMLElement {
  constructor() {
    super();

    this.findInStorePopup = this.querySelector(".find-in-store__popup");
    this.closeButton = this.querySelector(".close-svg");
    this.locationsWrapper = this.querySelector(".locations__wrapper");
    this.locations = this.querySelectorAll(".location") || [];
    this.checkAvailabilityBtn = this.querySelectorAll(".check-availability-btn") || [];
    this.heading = this.querySelector(".heading");
    this.warningMsg = document.querySelector(".variant-warning-msg");
    this.errorMessage = this.querySelector(".error__message");
    this.backgroundOverlay = document.querySelector(".background-overlay");
    this.productContainer = document.querySelector(".product-page.product");
    this.sectionHeader = document.querySelector("#shopify-section-header");
    this.url = this.dataset.url;
    this.variantRadios = this.querySelector("variant-radios")
    this.labels = this.variantRadios ? this.variantRadios.querySelectorAll("fieldset label") : []
    this.inventoryAPI = this.dataset.api || "";

    if (this.checkAvailabilityBtn.length > 0) {
      this.checkAvailabilityBtn.forEach((btn, index) => {
        btn.addEventListener("click", () => this.hasVariantSelected(index));
      })
      this.addEventListener("click", (e) => {
        if (e.target.hasAttribute("data-to-open")) {
          this.hasVariantSelected();
        }
      });
    }

    this.closeButton?.addEventListener("click", () => this.closePopup());
    this.backgroundOverlay?.addEventListener("click", () => this.closePopup());
    this.addEventListener("click", (e) => {
      if (e.target.classList.contains("find-in-store__popup") && e.target.classList.contains("active")) {
        this.closePopup();
      }
    })
  }

  closePopup() {
    this.findInStorePopup?.classList.remove("active");
    this.backgroundOverlay?.classList.add("hidden");
    document.body.classList.remove("overflow-hide");
    if (this.sectionHeader) this.sectionHeader.classList.remove("adjust-z-index");
    if (this.productContainer) this.productContainer.classList.remove("adjust-z-index");
  }

  hasVariantSelected(index) {
    const currSelectedVariant =
      document.querySelector(
        '.variant-radios-wrapper input[type="radio"]:checked'
      ) ||
      document.querySelector(
        "variant-radios input[type='radio']:checked"
      );

    this.warningMsg?.classList.add("hidden"); // Hide warning initially

    if (this.checkAvailabilityBtn[index]) this.checkAvailabilityBtn[index].classList.add("active"); // This will show loading spinner

    if (currSelectedVariant || this.hasAttribute("data-default")) {
      const form = document.querySelector(".product__info-wrapper .product-form");

      if (form) {
        const input = form.querySelector('input[name="id"]');

        if (input && input.value !== "") {
          this.getVariantSKU(input.value);
        }
      }
    } else {
      // Show error if no variant selected
      const message = this.errorMessage.dataset.content;
      this.handleErrorMessage(message);
      this.enableVariantSelectors();
      this.checkAvailabilityBtn.forEach(btn => {
        btn.classList.remove("active");
      })

      // Data layer event when variant is not selected
      this.handleDataLayerEvent("", false)
    }
  }

  async getAvailabilityDetails(SKU) {

    try {
      const response = await fetch(this.inventoryAPI, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ sku: SKU }),
      });

      if (!response.ok) throw new Error("Inventory API request failed");

      const data = await response.json();
      return { data, result: true };
    } catch (err) {
      console.error("Error fetching availability:", err);
      return { data: err, result: false };
    }
  }

  async getVariantSKU(ID) {
    try {
      const response = await fetch(`${this.url}.json`);

      if (!response.ok) {
        throw new Error(`Failed to fetch product data: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();
      if (!data?.product?.variants) throw new Error("No variants found.");

      const matchedVariant = data.product.variants.find(
        (variant) => String(variant.id) === String(ID)
      );

      if (matchedVariant) {
        const sku = matchedVariant.sku || "SKU not available";

        const results = await this.getAvailabilityDetails(sku);

        // Hide the popup
        this.findInStorePopup?.classList.remove("active");
        this.backgroundOverlay?.classList.add("hidden");
        if (this.sectionHeader) this.sectionHeader.classList.remove("adjust-z-index");
        if (this.productContainer) this.productContainer.classList.remove("adjust-z-index");

        if (this.variantRadios) this.variantRadios.classList.add("hidden")
        this.checkAvailabilityBtn.forEach(ele => {
          if (ele.closest(".find-in-store__popup")) {
            ele.classList.add("hidden")
          }
        })

        if (results.result) {
          const content = this.heading.dataset.content;
          this.heading.textContent = content;

          const locations = results.data?.locations || [];

          locations.forEach((location) => {
            const facility = location.facility;

            const matchedLocation = Array.from(this.locations).find(ele => Number(ele.dataset.facility) === facility);

            if (matchedLocation) {
              const availability = matchedLocation.querySelector(".availability");

              if (availability) {
                availability.textContent = location.available ? "Available" : "Not Available";
              }
            }
          });

          // update success popup state
          if (this.sectionHeader) this.sectionHeader.classList.add("adjust-z-index");
          if (this.productContainer) this.productContainer.classList.add("adjust-z-index");

          this.locationsWrapper?.classList.remove("hidden");
          this.errorMessage?.classList.add("hidden");
          this.findInStorePopup?.classList.add("active");
          if (window.matchMedia(("max-width: 749px")).matches) this.backgroundOverlay?.classList.remove("hidden");

          // Data layer event
          this.handleDataLayerEvent(ID, true)
        } else {
          // update error popup state
          this.handleErrorMessage(results.data);
        }

        // Disable background scroll
        // document.body.classList.add("overflow-hide");
      }
    } catch (error) {
      console.error("Error in getVariantSKU:", error.message);
      this.handleErrorMessage(error.message);
    } finally {
      this.checkAvailabilityBtn.forEach(btn => {
        btn.classList.remove("active");
      })
    }
  }

  handleDataLayerEvent(ID, isVariantSelected) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "find_in_store",
      pageHandle: this.url,
      isVariantSelected: isVariantSelected,
      variantId: ID,
      deviceType: this.getDeviceType()
    });
  }

  getDeviceType() {
    const ua = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(ua)) return "Android";
    if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return "iOS";
    if (/windows phone/i.test(ua)) return "Windows Phone";

    return "Desktop";
  }

  handleErrorMessage(message) {
    this.heading.textContent = "";

    this.errorMessage.textContent = message;

    this.warningMsg?.classList.remove("hidden");
    this.findInStorePopup?.classList.add("active");
    if (window.matchMedia(("max-width: 749px")).matches) this.backgroundOverlay?.classList.remove("hidden");
    this.locationsWrapper?.classList.add("hidden");
    this.errorMessage?.classList.remove("hidden");
  }

  enableVariantSelectors() {

    if (!this.variantRadios && this.labels.length === 0) return

    this.checkAvailabilityBtn.forEach(ele => {
      if (ele.closest(".find-in-store__popup")) ele.classList.remove("hidden")
    })

    this.variantRadios.classList.remove("hidden")

    this.labels.forEach(label => {
      label.addEventListener("click", () => {

        this.labels.forEach(ele => ele.classList.remove("selected"))
        label.classList.add("selected")
      })
    })
  }
}

customElements.define("find-in-store", FindInStore);


// Product Info Tabs
class ProductInfoTabs extends HTMLElement {
  constructor() {
    super();

     this.infoTabTitles = this.querySelectorAll(".info-tabs-title .tab-title") || [];
     this.infoTabContents = this.querySelectorAll(".info-tabs-content .tab-content") || [];
  }

  connectedCallback() {
    if (this.infoTabTitles.length > 0 && this.infoTabContents.length > 0) {

      this.infoTabTitles[0].classList.add("active");
      this.infoTabContents[0].classList.remove("hidden");

      this.infoTabTitles.forEach(title => {
        title.addEventListener("click", () => {

          const targetContentId = title.id;
          const targetContent = Array.from(this.infoTabContents).find(content => content.id === targetContentId);

          if (targetContent) {
            this.infoTabContents.forEach(content => content.classList.add("hidden"));
            this.infoTabTitles.forEach(t => t.classList.remove("active"));

            title.classList.add("active");
            targetContent.classList.remove("hidden");
          }
        })
      })
    }
  }
}

customElements.define("product-info-tabs", ProductInfoTabs);

// Programatic scroll
window.isProgrammaticScroll = false;

window.scrollToItem = function (element) {
  element.scrollIntoView({ behavior: "smooth", block: "start" });

  // Flag to pause window.scroll events
  window.isProgrammaticScroll = true;

  // allow scroll listener again after animation
  setTimeout(() => {
    window.isProgrammaticScroll = false;
  }, 1000); // match smooth scroll duration
}

// PDP Media Gallery Scroll Event to update thumbnail images

const thumbnails = document.querySelectorAll(".carousel-gallery .thumbnail-list__item .thumbnail") || [];
const mediaContainer = document.querySelector(".carousel-gallery .product__media-list");

if (thumbnails.length > 0 && mediaContainer) {

  const items = [...mediaContainer.children];

  if (items.length === 0) {
    console.warn("Items not found");
  }

  // Add active class to first elements on load
  items[0]?.classList.add("active");
  thumbnails[0]?.classList.add("active");

  window.addEventListener("scroll", () => {

    if (window.isProgrammaticScroll) return;

    let closestTop = Infinity;
    let currIndex = 0;

    items.forEach((el, index) => {
      const top = Math.abs(el.getBoundingClientRect().top - 90);

      if (top < closestTop) {
        closestTop = top;
        currIndex = index;
      }
    });

    thumbnails.forEach(el => el.classList.remove("active"));
    items.forEach(el => el.classList.remove("active"));

    items[currIndex]?.classList.add("active");
    thumbnails[currIndex]?.classList.add("active");
  });
}

// Change the Grid property value of payment and Find in store container
const paymentAndFindinStoreBlock = document.querySelector(".payment-and-find-in-store-block");

if (paymentAndFindinStoreBlock) {
  const EMI_Block = paymentAndFindinStoreBlock.querySelector(".emi-payment-gateway");
  const blockWidth = EMI_Block ? '50%' : '100%';

  paymentAndFindinStoreBlock.style.setProperty("--block-width", blockWidth);
}


// Update Sticky top value of Product info
function usingMainProduct() {
  const mainProduct = document.querySelector(".main-product");
  const sectionHeader = document.querySelector("#shopify-section-header");

  let value = 0;

  if (mainProduct && sectionHeader) {
    const padding = window.getComputedStyle(mainProduct).paddingTop;
    value = padding ? parseInt(padding, 10) : 10; // 10px
  }

  return value;
}

window.updateStickyvalue = function() {
  const variantRadios = document.querySelector("variant-radios");
  const productInfo = document.querySelector(".product__info-wrapper");

  if (!variantRadios || !productInfo) return;

  const sectionHeader = document.querySelector("#shopify-section-header");
  const headerHeight = sectionHeader ? sectionHeader.offsetHeight : 90; // 90px default height

  const safeArea = 5; // 5px
  const value = usingMainProduct();

  const parentOffsetTop = (value ? value : productInfo.offsetTop) + headerHeight;
  const childOffsetTop = variantRadios.offsetTop;

  const stickyValue = parentOffsetTop - (childOffsetTop + safeArea);

  productInfo.style.setProperty("--sticky-top-value", `${stickyValue}px`);
}

// The sticky value may be calculated too early because similar products are added dynamically.
// To ensure accurate positioning, we continuously recalculate the sticky value for 2.5 seconds.
// This prevents the sticky element from getting “stuck” or jumping when new content is inserted.

let startTime = performance.now(); // record start time
const duration = 2500;

function updateStickyLoop(timestamp) {
  window.updateStickyvalue(); // update sticky

  if (timestamp - startTime < duration) { // run for few seconds
    requestAnimationFrame(updateStickyLoop);
  }
}

// Start the loop
requestAnimationFrame(updateStickyLoop);


// Product card slider
class MediaSliderButton extends HTMLElement {
  constructor() {
    super()

    const selc = {
      prev: "#media-slider-button-prev",
      next: "#media-slider-button-next",
      card: ".card__inner",
      slider: "#slider-media"
    }

    this.prevButton = this.querySelector(selc.prev)
    this.nextButton = this.querySelector(selc.next)
    this.currentSlide = 0

    this.card = this.closest(selc.card)
    this.cardMedia = this.card ? this.card.querySelector(".card__media") : null
    this.mediaSlider = this.card ? this.card.querySelector(selc.slider) : null

    // Initialize functions
    this.initFunc()
  }

  initFunc() {
    if (this.mediaSlider && this.prevButton && this.nextButton) {
      this.mediaCount = parseInt(this.mediaSlider.dataset.mediaCount, 10) || 1
      this.mediaSliderWidth = this.mediaSlider.offsetWidth

      this.prevButton.addEventListener("click", () => this.moveToPrevSlide())
      this.nextButton.addEventListener("click", () => this.moveToNextSlide())

      let timeout;

      this.mediaSlider.addEventListener("scroll", (e) => {

          clearTimeout(timeout) // Update the slide and progress only once
  
          timeout = setTimeout(() => {
            const scrolledWidth = Math.floor(e.target.scrollLeft) || 0
            this.currentSlide = Math.round(scrolledWidth / this.mediaSliderWidth) || 0
            this.updateProgress()
          }, 100)
      }, { passive: true })

      this.updateSlide()
      this.updateProgress()
    }
  }
  moveToPrevSlide() {
    if (this.currentSlide > 0) this.currentSlide--
    this.updateSlide()
    this.updateProgress()
  }
  moveToNextSlide() {
    if (this.currentSlide < (this.mediaCount - 1)) this.currentSlide++

    this.updateSlide()
    this.updateProgress()
  }
  updateSlide() {
    this.mediaSlider.scrollLeft = this.mediaSliderWidth * this.currentSlide
  }
  updateProgress() {
    this.barProgress = (100 / this.mediaCount) * (this.currentSlide + 1)
    if (this.cardMedia) this.cardMedia.style.setProperty('--slider-progress', `${this.barProgress}%`)
  }
}

customElements.define("media-slider-buttons", MediaSliderButton)

// Accordion type opening for Mobile menu > Brands childlinks
const brandsContainer = document.querySelector("#link-brands")

if (brandsContainer) {
  const childlinkTitles = brandsContainer.querySelectorAll("[data-childlink-title]") || []
  const childlinkContents = brandsContainer.querySelectorAll("[data-childlink-content]") || []

  if (childlinkTitles && childlinkContents) {
    childlinkContents[0].style.maxHeight = childlinkContents[0].scrollHeight + "px"; // Open the first content

    childlinkTitles.forEach((title, index) => {
      title.removeAttribute("href") // Remove the link so it won't redirect

      title.addEventListener("click", () => {
        childlinkContents.forEach(el => {el.style.maxHeight = "0px"});
        childlinkContents[index].style.maxHeight = childlinkContents[index].scrollHeight + "px";
      })
    })
  }
}

// Product description read more functionality
class TruncateDescription extends HTMLElement {
  constructor() {
    super()

    this.container = this.closest(".info-tabs-content")
    this.noscript = this.container?.querySelector("#description-data")

    this.open = false
    this.truncated = null
    this.full = null

    if (!this.noscript) return

    try {
      const parsed = new DOMParser().parseFromString(this.noscript.innerHTML, "text/html")

      const element = parsed.querySelector(".description-data")
      const data = JSON.parse(element.dataset.description)

      const truncated = data.truncated_description || ""
      const full = data.full_description || ""

      if (truncated && full) {
        this.render(truncated, full)
        this.addEventListener("click", () => this.toggleDescription())
      }

    } catch (err) {
      console.error("Error parsing description:", err)
      return;
    }
  }

  render(truncatedContent, fullContent) {
    this.truncated = document.createElement("textarea")
    this.full = document.createElement("textarea")

    this.truncated.innerHTML = truncatedContent
    this.full.innerHTML = fullContent

    this.innerHTML = this.truncated.value // Show truncated value initially
  }

  toggleDescription() {
    this.innerHTML = this.open ? this.truncated.value : this.full.value
    this.open = !this.open
  }
}

customElements.define("truncate-description", TruncateDescription)


// Floating Cart Widget

window.updateFloatingCart = function () {
  const floatingCart = document.getElementById("floating-cart");
  const floatingCartInner = document.getElementById("floating-cart-inner");

  if (floatingCart && floatingCartInner) {
    floatingCart.innerHTML = floatingCartInner.innerHTML;
  }
}

class FloatingCart extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('click', () => {
            const cartBubble = document.querySelector('#cart-icon-bubble');
            if (cartBubble) cartBubble.click();
        })
    }
}

customElements.define('floating-cart', FloatingCart);

// Shop the look hotspot functionality
class ShopTheLook extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const hotspotButtons = this.querySelectorAll(".shop-the-look-hotspot-button");
    const hotspotCards = this.querySelectorAll(".shop-the-look-product-card");

    hotspotButtons.forEach(hotspot => {
      hotspot.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.callQuickAdd(hotspot);
      });
    });

    hotspotCards.forEach(card => {
      card.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.callQuickAdd(card);
      });
    });
  }

  callQuickAdd(ele) {
    const index = ele.dataset.index;
    if (!index) return;
    const matchedQuickAdd = this.querySelector(`.quick-add-to-cart-icon[data-index='${index}'] .desktop-buy-button`);
    if (matchedQuickAdd) {
      matchedQuickAdd.click();
    }
  }
}

customElements.define('shop-the-look', ShopTheLook);